import { ApiResponse } from '../model/base';
import {
  IVideoList,
  SignData,
  VideoCard,
  VideoResponse,
  VideoStatusResponse,
} from '../model/home';
import { getData, postData } from '../utils/HttpUtils';

export async function getImgUploadSignInfo(
  content_type: string,
  ext_type: string,
): Promise<SignData> {
  const res = await postData('/api/solve/sign_resource', {
    content_type,
    ext_type,
  });
  return res;
}

export async function analyzeUserInput(
  question: string,
  image: string,
  file: string,
  video_id?: string,
): Promise<VideoResponse> {
  return postData('/api/solve/video_generate', {
    question,
    image,
    file,
    video_id,
  });
}

export async function getVideoStatus(
  video_id: string,
): Promise<VideoStatusResponse> {
  return getData('/api/solve/video_status', {
    video_id,
  });
}
export async function getRecomVideoList(): Promise<{
  ref_id: string;
  cards: VideoCard[] | null;
}> {
  return getData('/api/solve/home_recom_cards');
}

export async function getMyVideoList(ref_id?: string): Promise<IVideoList> {
  return getData('/api/solve/home_user_cards', ref_id ? { ref_id } : {});
}
export async function deleteMyVideo(video_id: string) {
  return postData('/api/solve/video_delete', { video_id });
}
export async function reGenerate(video_id: string) {
  return postData('/api/solve/video_regenerate', { video_id });
}
export async function cancelGenerate(video_id: string) {
  return postData('/api/solve/video_cancel', { video_id });
}
export async function cancelSolve(video_id: string) {
  return postData('/api/solve/intention_cancel', { video_id });
}
